// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"41":"error","321":"core","860":"menu"}[chunkId] + "." + {"41":"d4c5b213","321":"b6b0827d","860":"6241956e"}[chunkId] + ".css";
};